import React from 'react';
import Raven from 'raven-js';
import { connect } from 'react-redux';
import { LandingContainer } from '../landing/landing';
import { loadUser } from '../../state/auth/actions';
import { JobsContainer } from '../jobs/jobs';

const Index = React.createClass({
  componentWillMount() {
    if (process.env.REACT_APP_SENTRY_IS_LOGGING === 'true') {
      Raven.config(process.env.REACT_APP_SENTRY_DSN).install();
    }

    // Refresh authed users on page reload
    if (this.props.isAuthenticated) {
      this.props.dispatch(loadUser());
    }
  },

  render() {
    const { isAuthenticated } = this.props;
    return isAuthenticated ? (
      <JobsContainer {...this.props} />
    ) : (
      <LandingContainer {...this.props} />
    );
  }
});

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.get('isAuthenticated'),
    account: state.auth.get('user')
  };
};

export const IndexContainer = connect(mapStateToProps)(Index);



/** WEBPACK FOOTER **
 ** ./src/components/index/index.jsx
 **/